import axios from 'axios';
import { API_URL } from '../config/apiConfig';

/**
 * Service for managing idle timeout settings
 */
const IdleTimeoutService = {
  /**
   * Get the idle timeout settings
   * @returns {Promise<Object>} Object containing idle timeout settings
   */
  getSettings: async () => {
    try {
      // Get idle timeout enabled setting
      const enabledResponse = await axios.get(`${API_URL}/api/settings/idleTimeoutEnabled`);
      
      // Get idle timeout duration setting
      const durationResponse = await axios.get(`${API_URL}/api/settings/idleTimeoutDuration`);
      
      return {
        enabled: enabledResponse.data.value,
        duration: durationResponse.data.value
      };
    } catch (error) {
      console.error('Error fetching idle timeout settings:', error);
      // Return default values if there's an error
      return {
        enabled: true,
        duration: 5
      };
    }
  },
  
  /**
   * Update the idle timeout enabled setting
   * @param {boolean} enabled - Whether idle timeout is enabled
   * @returns {Promise<Object>} Updated setting
   */
  updateEnabledSetting: async (enabled) => {
    try {
      const response = await axios.put(`${API_URL}/api/settings/idleTimeoutEnabled`, {
        value: enabled,
        description: 'Enable/disable automatic logout for idle users'
      });
      
      return response.data;
    } catch (error) {
      console.error('Error updating idle timeout enabled setting:', error);
      throw error;
    }
  },
  
  /**
   * Update the idle timeout duration setting
   * @param {number} duration - Duration in minutes
   * @returns {Promise<Object>} Updated setting
   */
  updateDurationSetting: async (duration) => {
    try {
      const response = await axios.put(`${API_URL}/api/settings/idleTimeoutDuration`, {
        value: duration,
        description: 'Duration in minutes before automatically logging out idle users'
      });
      
      return response.data;
    } catch (error) {
      console.error('Error updating idle timeout duration setting:', error);
      throw error;
    }
  }
};

export default IdleTimeoutService;
